module.exports = __webpack_public_path__ + "static/media/logo-green-1x.4c42c11f.png";